export default defineNuxtPlugin(() => {
  const route = useRoute();
  const runtimeConfig = useRuntimeConfig();

  // Define tracking-related parameters we want to capture
  const trackingParams = [
    'gclid', 'fbclid', 'ttclid', 
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'
  ];

  // Extract only tracking-related query parameters
  const relevantParams: Record<string, any> = {};
  for (const param of trackingParams) {
    if (route.query[param]) {
      relevantParams[param] = route.query[param];
    }
  }
  
  if (Object.keys(relevantParams).length > 0) {
    // Set cookie with 30 days TTL
    const pbCookie = useCookie('pb-log', {
      domain: runtimeConfig.public.pb?.domainHost,
      maxAge: 60 * 60 * 24 * 30, // 30 days in seconds
      httpOnly: false,
      secure: process.env.NODE_ENV === 'production',
      sameSite: 'lax',
      default: () => ({})
    });
    
    try {
      // Get existing cookie data or initialize as empty object
      let existingData = {};
      if (pbCookie.value && typeof pbCookie.value === 'string') {
        try {
          // Try to parse as JSON first
          existingData = JSON.parse(pbCookie.value);
        } catch (parseError) {
          // If JSON parse fails, try URL decoding first
          try {
            const decodedValue = decodeURIComponent(pbCookie.value);
            existingData = JSON.parse(decodedValue);
          } catch (decodeError) {
            console.warn('Failed to parse existing cookie data, starting fresh:', decodeError);
            existingData = {};
          }
        }
      }
      
      // Merge new tracking parameters with existing data
      // New parameters will overwrite existing ones with same key
      const mergedData = {
        ...existingData,
        ...relevantParams,
        lastUpdated: new Date().toISOString()
      };
      
      // Store the merged data as JSON string
      pbCookie.value = JSON.stringify(mergedData);
    } catch (error) {
      // If there's an error parsing existing cookie, just store new params
      console.warn('Error parsing existing pb-log cookie, storing new params:', error);
      const newData = {
        ...relevantParams,
        lastUpdated: new Date().toISOString()
      };
      pbCookie.value = JSON.stringify(newData);
    }
  }
});
